"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoHostingInfoProperty = getVideoHostingInfoProperty;
exports.findVideoInfoByProvider = findVideoInfoByProvider;
exports.wrapTrackHubLVideoInteraction = exports.isHubLVideo = exports.getHubLVideoPlayerIdFromFile = exports.getHubLVideoParamObjectFromFile = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Constants = require("FileManagerCore/Constants");

var _getIn = _interopRequireDefault(require("FileManagerCore/utils/getIn"));

function getVideoHostingInfoProperty(file) {
  return (0, _getIn.default)(file, _Constants.PATH_TO_VIDEO_HOSTING_INFO);
}

function findVideoInfoByProvider(file, provider) {
  var hostingInfoList = getVideoHostingInfoProperty(file);

  if (hostingInfoList) {
    return hostingInfoList.find(function (e) {
      return e.provider === provider && e.status === 'ENABLED';
    }) || {};
  }

  return {};
}

var getHubLVideoParamObjectFromFile = function getHubLVideoParamObjectFromFile(file) {
  var width = file.width,
      height = file.height;

  if (getVideoHostingInfoProperty(file)) {
    return (0, _extends2.default)({}, file.meta.video_data, {
      width: width,
      height: height,
      player_id: findVideoInfoByProvider(file, _Constants.VideoProviders.VIDYARD).id
    });
  }

  return {};
};

exports.getHubLVideoParamObjectFromFile = getHubLVideoParamObjectFromFile;

var getHubLVideoPlayerIdFromFile = function getHubLVideoPlayerIdFromFile(file) {
  return getHubLVideoParamObjectFromFile(file).player_id;
};

exports.getHubLVideoPlayerIdFromFile = getHubLVideoPlayerIdFromFile;

var isHubLVideo = function isHubLVideo(file) {
  return !!getHubLVideoPlayerIdFromFile(file);
};

exports.isHubLVideo = isHubLVideo;

var wrapTrackHubLVideoInteraction = function wrapTrackHubLVideoInteraction(trackInteraction) {
  return function (action) {
    return trackInteraction('Accept Video TOS', action);
  };
};

exports.wrapTrackHubLVideoInteraction = wrapTrackHubLVideoInteraction;